export default "__VITE_ASSET__BZfPZLyb__"